import React, { type ComponentType, lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import {
  HideRetailerAgnosticStoreConfigs,
  OnlyStorefrontPro,
  ViewType,
} from '@retailer-platform/dashboard/gin-and-tonic'
import { DomainRoute } from '../utils/domain/routingComponents'
import {
  adminStorefrontSetupViewAccessControl,
  whitelabelSiteCustomizableStringsViewAccessControl,
} from '../access-control/onboardingAccess.configuration'

const OnboardingSiteSetupPage = lazy(() => import('../pages/site-setup/OnboardingSiteSetupPage'))
const OnboardingStringCustomizationsPage = lazy(
  () =>
    import(
      /* webpackChunkName: "OnboardingStringCustomizationsPage" */
      '../pages/string-customizations/OnboardingStringCustomizationsPage'
    )
)
// @hygen:inject page-import

export const onboardingStoreConfigScopedRouter = (
  <DomainRoute route="onboarding-site-scoped">
    <DashSwitch>
      <DomainRoute
        exact
        route="onboarding-site-setup"
        component={OnboardingSiteSetupPage as ComponentType<any>}
        accessControl={adminStorefrontSetupViewAccessControl}
        scopePicker={{
          titles: ['onboardingDomain.siteSetup.title'],
          selectionType: ViewType.RETAILER_AND_STORE_CONFIG,
          storeConfigFilter: HideRetailerAgnosticStoreConfigs,
        }}
      />
      <DomainRoute
        exact
        route="onboarding-string-customizations"
        tool="string-customization-dashboard-tool"
        component={OnboardingStringCustomizationsPage as ComponentType<any>}
        scopePicker={{
          titles: ['onboardingDomain.stringCustomization.page.title'],
          selectionType: ViewType.RETAILER_AND_STORE_CONFIG,
          storeConfigFilter: HideRetailerAgnosticStoreConfigs,
        }}
        accessControl={whitelabelSiteCustomizableStringsViewAccessControl}
      />
      <DomainRoute
        exact
        route="onboarding-string-customizations-storefront-pro"
        tool="string-customization-dashboard-tool"
        component={OnboardingStringCustomizationsPage as ComponentType<any>}
        scopePicker={{
          titles: ['onboardingDomain.stringCustomization.page.title'],
          selectionType: ViewType.RETAILER_AND_STORE_CONFIG,
          storeConfigFilter: sites => OnlyStorefrontPro(HideRetailerAgnosticStoreConfigs(sites)),
        }}
        accessControl={whitelabelSiteCustomizableStringsViewAccessControl}
      />
      {/* @hygen:inject router-route
        injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
